<bzg-modal-header>
  <span class="bzg-modal__header">{{ data.title }}</span>
  <bzg-button-icon class="" icon="icon-close" (click)="close()"></bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
  <span [innerHTML]="data.message"></span>
</bzg-modal-content>
<bzg-modal-footer>
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m" [ngClass]="{'color-cancel-button': isDisabledColorButton}">{{ data.cancelButton || ('GLOBAL.CANCEL' | translate) }}
  </bzg-button-secondary>
  <bzg-button-primary (click)="confirmation()" class="action-confirmation-button" [ngClass]="{'action-confirmation-button--confirmation': isConfirmation, 'action-confirmation-button--danger': !isConfirmation}">
  {{ data.button}}
  </bzg-button-primary>
</bzg-modal-footer>
